export const replaceById = <T extends { id: string }>(array: T[] | undefined, newItem: T): T[] => {
    if (array == null) {
        return [];
    }

    return array.map((item) => (item.id === newItem.id ? newItem : item));
};